import { CHAT_INPUT_WARNING_SURFACE } from '@/components'
import { cn } from '@/lib/utils'

interface WorkbenchComposerTabProps {
  /** The AI has never seen this chart. */
  first: boolean
}

/**
 * The folder tab on top of the composer while workbench changes are waiting:
 * "Chart updated" ("Send chart to AI" on a first share). It is the only tab
 * — a label, not a control — there to make plain that the box below now sends
 * the chart along with whatever is typed.
 */
export default function WorkbenchComposerTab({ first }: WorkbenchComposerTabProps) {
  return (
    // -mb-px: the tab covers the card's top border and reads as one piece with it.
    // Flush left, so its left edge runs straight into the card's (which squares its
    // corner under it — see BotChat's cardClassName).
    <div className="relative z-10 -mb-px flex items-end">
      <div
        data-testid="workbench-composer-tab"
        className={cn(
          'inline-flex items-center h-8 px-3 rounded-t-lg border border-b-0 text-label text-warning font-medium',
          CHAT_INPUT_WARNING_SURFACE,
        )}
      >
        {first ? 'Send chart to AI' : 'Chart updated'}
      </div>
    </div>
  )
}
